<template>
  <div id="BaseHeader" class="noprint">
    <HeaderTopBar
      :theme="tenantDetails.theme"
      :should-show-nav-icons="shouldShowNavIcons"
      @openSideCart="openSideCart"
    />
    <HeaderSearchBar :should-show-search-controls="shouldShowSearchControls" />
    <HeaderMainMenu v-if="shouldShowMainMenu" class="d-none d-sm-block" />

    <HeaderMainMenuSmScreen v-if="shouldShowMainMenu" class="d-block d-sm-none d-md-none d-lg-none" />

    <div v-if="shouldShowNavIcons" class="container">
      <breadcrumbs />
    </div>
  </div>
</template>

<script>
  import { mapGetters } from "vuex"
  import HeaderTopBar from "@/components/Header/HeaderTopBar"
  import HeaderSearchBar from "@/components/Header/HeaderSearchBar.vue"
  import HeaderMainMenu from "@/components/Header/HeaderMainMenu"
  import HeaderMainMenuSmScreen from "@/components/Header/HeaderMainMenuSmScreen"
  import Breadcrumbs from "@/components/Header/Breadcrumbs"
  import { UserService } from "@/services/UserService"
  import { FeatureFlagService } from "@/services/FeatureFlagService";
  import { constants } from "@/const";
  import { TourService } from "@/services/TourService";

export default {
  components: {
    HeaderTopBar,
    HeaderSearchBar,
    HeaderMainMenu,
    HeaderMainMenuSmScreen,
    Breadcrumbs,
  },
  props: {
    shouldShowNavIcons: {
      type: Boolean,
      default: true,
    },
    shouldShowSearchControls: {
      type: Boolean,
      default: true,
    },
    shouldShowMainMenu: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      showTourOEMSearch: false,
    };
  },
  created() {
    this.showTourOEMSearch = FeatureFlagService.getFeatureEnabled(constants.FEATURE_NAMES.TOUR_OEM_SEARCH);
  },
  computed: {
    ...mapGetters(["tenantDetails", "user", "activeDealer"]),
  },
  methods: {
    openSideCart() {
      this.$emit("openSideCart");
    },
    async loadTourIfEligible() {
      // Hardcoded name for the parts lookup tour
      let tourName = "OEM Search Tour";
      let hasUserTourRecord = false;
      let isOddBrandAuth = false;
      let tourId = null;

      // Validate the user ID before proceeding
      const userId = Number(this.user?.UserId);
      if (!Number.isInteger(userId) || userId <= 0) {
        return;
      }

      try {
        const brandAuth = Number(this.activeDealer?.BrandAuth);
        isOddBrandAuth = Number.isInteger(brandAuth) && brandAuth % 2 !== 0;

        // Fetch the tour information for the specified tour name
        const toursResponse = await UserService.GetTour(tourName, constants.DealernetClientId, true);
        const tours = Array.isArray(toursResponse?.data) ? toursResponse.data : [];
        
        // Get the first tour and its ID if available
        const firstTour = tours[0];
        tourId = Number(firstTour?.TourId) || null;
        const tourIds = firstTour && firstTour.TourId ? [firstTour.TourId] : [];
        const tourNames = [tourName];
        
        // Fetch the user's tour record for the specified tour
        const userToursResponse = await UserService.GetUserTour(userId, constants.DealernetClientId, tourIds, tourNames);
        const userTours = Array.isArray(userToursResponse?.data) ? userToursResponse.data : [];

        // Check if user has completed or cancelled the tour
        hasUserTourRecord = userTours.some((tour) => {
          if (!tour || !tour.EndDate) {
            return false;
          }
          const parsedDate = new Date(tour.EndDate);
          return !Number.isNaN(parsedDate.getTime());
        });
      } catch (error) {
        hasUserTourRecord = false;
      }

      if (this.user && this.user.UserId && this.showTourOEMSearch && isOddBrandAuth && !hasUserTourRecord) {
        TourService.startTour(tourName, {userId, tourId});
      }
    },
  },
  async mounted() {
    if (Number(this.user?.UserId) > 0) {
      await this.loadTourIfEligible();
      return;
    }

    const unwatch = this.$watch("user.UserId", async (val) => {
      if (Number(val) > 0) {
        unwatch();
        await this.loadTourIfEligible();
      }
    });
  },
};
</script>
